import { render, staticRenderFns } from "./ListProduct.vue?vue&type=template&id=08022a80&scoped=true"
import script from "./ListProduct.vue?vue&type=script&lang=js"
export * from "./ListProduct.vue?vue&type=script&lang=js"
import style0 from "./ListProduct.vue?vue&type=style&index=0&id=08022a80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08022a80",
  null
  
)

export default component.exports